import BaseWrapper from "../../components/BaseWrapper/BaseWrapper"
import { FormProvider } from "../../contexts/CreateRecordFormContext"
import { AddCircle, Construction } from "@mui/icons-material"
import CatalogColumns from "../../lib/TableColumns/CatalogColumns"
import { useEffect, useState } from "react"
import { API } from "../../lib/api"
import RecordModal from "../../components/RecordModal/RecordModal"
import Feedback from "../../components/Feedback/Feedback"
import CollapsibleGridCard from "../../components/CollapsibleGridCard"


const Catalogs = () => {
    // -- Page State -- //
    const [catalogData, setCatalogData] = useState([])
    const columns = CatalogColumns()
    const [openCreateModal, setOpenCreateModal] = useState(false)
    const [openUpdateModal, setOpenUpdateModal] = useState(false)
    const [feedback, setFeedback] = useState({})
    const [selectedRows, setSelectedRows] = useState([])

    // -- Modal Handlers -- //
    const handleOpenCreateModal = () => setOpenCreateModal(true)
    const handleCloseCreateModal = () => setOpenCreateModal(false)
    const handleOpenUpdateModal = () => selectedRows.length ? setOpenUpdateModal(true) : setFeedback({open: true, message: "Select at least one record to update!", type: "info"})
    const handleCloseUpdateModal = () => setOpenUpdateModal(false)

    // -- Grid Selection -- //
    const handleSelectionChange = (selection) => setSelectedRows(selection)

    // -- Local State Helpers -- //
    const addCatalog = (newCatalog) => setCatalogData(prevCatalogs => [...prevCatalogs, newCatalog]);

    // -- Create Catalog -- //
    const handleSubmit = async (data) => {
        const serverReadyData = {
            ...data,
            createdBy: localStorage?.id
        }

        const response = await API.Catalogs.Create(serverReadyData)

        if (response.status === 200) {
            addCatalog(response.data.data)
            setFeedback({open: true, message: response.data.message, type: "success"})
        } else {
            setFeedback({open: true, message: response?.data?.message || "Error Creating Catalog...", type: "error"})
        }

        handleCloseCreateModal()
    }

    // -- Update Catalogs -- //
    const handleUpdateSubmit = async (data) => {
        let updatedFields = {}

        Object.keys(data).forEach(key => {
            if (data[key]) {
                Object.assign(updatedFields, { [key]: data[key] } )
            }
        })

        const updatePayload = selectedRows.map((selectedRow) => ({
            _id: selectedRow,
            data: updatedFields
        }))

        const response = await API.Catalogs.UpdateMulti(updatePayload)

        if (response.status === 200) {
            setCatalogData(prevCatalogs =>
                prevCatalogs.map(catalog => {
                    const updated = response.data.data.find(update => update._id === catalog._id);
                    return updated ? updated : catalog;
                })
            );

            setFeedback(prevData => ({...prevData, open: true, message: response.data.message, type: 'success' }))
        } else {
            setFeedback(prevData => ({ ...prevData, open: true, message: response?.data?.message || "Error updating catalog(s)", type: 'error' }))
        }

        handleCloseUpdateModal(false)
    }

    // -- Delete Catalogs -- //
    const handleDeleteSubmit = async () => {
        const response = await API.Catalogs.Delete(selectedRows)

        if (response.status === 200) {
            setCatalogData(prevCatalogs =>
                prevCatalogs.filter(catalog => !selectedRows.includes(catalog._id))
            );
            setFeedback(prevData => ({ ...prevData, open: true, message: response.data.message, type: 'success' }))
        } else {
            setFeedback(prevData => ({ ...prevData, open: true, message: response.data.message || "Failed To Delete Catalog", type: 'error' }))
        }

        setSelectedRows([])
        handleCloseUpdateModal()
    }

    // -- Collapsible Grid Card Actions -- //
    const actionButtons = [
        { title: "Create New Catalog", onClick: handleOpenCreateModal, icon: AddCircle, color: "primary" },
        { title: "Update Selected Record(s)", onClick: handleOpenUpdateModal, icon: Construction, color: "primary" },
    ]

    // -- Record Modal Fields -- //
    const createCatalogFields = [
        { name: "name", label: "Name", type: "text", required: true },
    ]

    // -- Fetch Catalogs -- //
    useEffect(() => {
        async function fetchData() {
            const response = await API.Catalogs.FetchAll()
            setCatalogData(response)
        }

        fetchData()
    },[])

    return (
        <BaseWrapper
            content={
                <FormProvider>
                    <Feedback props={feedback} setFeedback={setFeedback} />
                    <RecordModal open={openCreateModal} title={"Create New Catalog"} onSubmit={handleSubmit} handleClose={handleCloseCreateModal} fields={createCatalogFields} />
                    <RecordModal open={openUpdateModal} handleClose={handleCloseUpdateModal} fields={createCatalogFields} title="Update Catalog(s)" onSubmit={handleUpdateSubmit} onDelete={handleDeleteSubmit} isUpdate={true} />

                    {/* -- Catalogs Grid -- */}
                    <div className="col-xl-12 col-md-12" style={{marginTop: "1em", marginBottom: "1em"}}>
                        <CollapsibleGridCard
                            title="Application Engineering"
                            linkLabel="Catalogs"
                            rows={catalogData}
                            columns={columns}
                            getRowId={(row) => row._id}
                            checkboxSelection
                            onRowSelectionModelChange={handleSelectionChange}
                            initialPageSize={15}
                            pageSizeOptions={[15, 25, 50]}
                            actionButtons={actionButtons}
                        />
                    </div>
                </FormProvider>
            }
        />
    )
}

export default Catalogs
